import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [message, setMessage] = useState(false);

  return (
    <div>
      <section className="container-fluid footer_section">
        <div className="container pt-4">
          <div className="row ">
            <div className="col-sm-6 col-md-4 col-lg-3 footer-col">
              <div className="footer_detail">
                <Link to="/">
                  <h4>Superpower</h4>
                </Link>
                <p>
                  Superpower is an academic project for our Coding Bootcamp. Selling prices are
                  fictional. None of the products displayed are being sold on this website.
                </p>
                <p>
                  To learn more about this project check the <Link to="/about">about us</Link> page.
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3 mx-auto footer-col">
              <Link to="/contact">
                <h4>Contact us</h4>
              </Link>

              <div className="mb-3">
                <p className="m-0">
                  Fernando Etcheverry
                  <a
                    href="https://www.linkedin.com/in/fernando-etcheverry-/"
                    target="_blank"
                    className="mx-2 text-white"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>
                  <a
                    href="https://github.com/FernandoEtcheverry"
                    target="_blank"
                    className="text-white"
                  >
                    <i className="bi bi-github"></i>
                  </a>
                </p>
                <a
                  href="mailto: ffetcheverry@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white text-decoration-underline"
                >
                  ffetcheverry@gmail.com
                </a>
              </div>

              <div className="mb-3">
                <p className="m-0">
                  Rosina González
                  <a
                    href="https://www.linkedin.com/in/rosinagonzalez/"
                    target="_blank"
                    className="mx-2 text-white"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>
                  <a
                    href="https://github.com/rosinagonzalez"
                    target="_blank"
                    className="text-white"
                  >
                    <i className="bi bi-github"></i>
                  </a>
                </p>
                <a
                  href="mailto: rgonzalezmajo@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white text-decoration-underline"
                >
                  rgonzalezmajo@gmail.com
                </a>
              </div>

              <div className="mb-3">
                <p className="m-0">
                  Fabricio Guido
                  <a
                    href="https://www.linkedin.com/in/fabricio-guido-cruz/"
                    target="_blank"
                    className="mx-2 text-white"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>
                  <a
                    href="https://github.com/Fabricio-Guido"
                    target="_blank"
                    className="text-white"
                  >
                    <i className="bi bi-github"></i>
                  </a>
                </p>
                <a
                  href="mailto: fbrcgd@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white text-decoration-underline"
                >
                  fbrcgd@gmail.com
                </a>
              </div>
            </div>
            <div className="col-md-4 footer-col">
              <div className="footer_form">
                <h4>SIGN UP TO OUR NEWSLETTER</h4>
                <div>
                  <input type="text" placeholder="Enter Your Email" />
                  <button onClick={() => setMessage(true)}>Subscribe</button>
                  {message && <p className="pt-1">We are sorry, this feature is not available.</p>}
                </div>
              </div>
            </div>
          </div>
          <div className="footer-info">
            <p>
              Copyright &copy; <span id="displayYear"></span> All Rights Reserved 2022
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
